import { render, staticRenderFns } from "./BsaMain.vue?vue&type=template&id=5d660e95&scoped=true"
import script from "./BsaMain.vue?vue&type=script&lang=js"
export * from "./BsaMain.vue?vue&type=script&lang=js"
import style0 from "./BsaMain.vue?vue&type=style&index=0&id=5d660e95&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d660e95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d660e95')) {
      api.createRecord('5d660e95', component.options)
    } else {
      api.reload('5d660e95', component.options)
    }
    module.hot.accept("./BsaMain.vue?vue&type=template&id=5d660e95&scoped=true", function () {
      api.rerender('5d660e95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/BsaMain.vue"
export default component.exports